<template>
<div id="bottom1">
    <div class="bg-color-black">
        <div class="cc-header">
            <dv-decoration-2 :color="['#4ccbda', '#4ccbda']" style="width:4rem;height:0.3rem;margin-left:0.2rem;transform: rotateY(180deg);" />
            <div>闸机设备地域分布</div>
            <dv-decoration-2 :color="['#4ccbda', '#4ccbda']" style="width:4rem;height:0.1rem;margin-right:0.2rem;" />
        </div>
        <div class="d-flex jc-center">
            <div id="mapChart" class="mapChart"></div>
        </div>
    </div>
</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
var region = storage.getItem("region");
const echarts = require("echarts");
export default {
    data() {
        return {};
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            var mapChart = echarts.init(document.getElementById("mapChart"));
            this.$http.get("/dataView/gate/getGateMapDistribution?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var result = res.data.result;
                    var mapJosn = "china";
                    if(region != 'false' && this.Map.mapMap.get(region) != undefined){
						mapJosn = this.Map.mapMap.get(region);
					}
                    var option = {
                        geo: {
                            map: mapJosn,
                            label: {
                                show: true,
                                textStyle: {
                                    color: '#0692a4',
									fontSize: fontSize(0.16)
                                },
                                emphasis: {
                                    show: true,
                                    textStyle: {
                                        color: '#fff'
                                    }
                                }
                            },
                            roam: true,
                            zoom: 1.2,
                            itemStyle: {
                                normal: {
                                    areaColor: "#142957",
                                    borderColor: "#0692a4"
                                },
                                emphasis: {
                                    areaColor: "#0b1c2d"
                                }
                            }
                        },
                        series: [{
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            zlevel: 1,
                            // symbolSize: function (val) {
                            //     return val[2] / 1;
                            // },
                            showEffectOn: 'render',
                            rippleEffect: {
                                brushType: 'stroke'
                            },
                            hoverAnimation: true,
                            label: {
                                normal: {
                                    formatter: '{b} : {@2}',
                                    position: 'top',
                                    show: true,
									textStyle: {
										fontSize: 15,
										color: '#f4e925'
									}
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#f4e925',
                                    shadowBlur: 11,
                                    shadowColor: '#333'
                                }
                            },
                            data: result
                        }]
                    };
                    mapChart.setOption(option);
                    window.addEventListener("resize", () => mapChart.resize(), false);
                }
            });
        }
    }
};
function fontSize(res){
    let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
    if (!clientWidth) return;
    let fontSize = 100 * (clientWidth / 1920);
    return res*fontSize;
}
</script>

<style lang="scss">
#bottom1 {
    height: 43vh;

    .cc-header {
        height: 0.4rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .mapChart {
        width: 11rem;
        height: 38vh;
    }
}
</style>
